/* eslint-disable */

/**
 * 存储通用组件, 支持单独调用其中每一个容器, 也可以使用global方法自动选择容器
 * @class HybridStorage
 */
class HybridStorage {
  constructor() {
    /**
     * @property {Object} cookie
     */
    this.cookie = (function () {
      const _domainArr = document.domain ? document.domain.split('.') : [];
      const _doArrLen = _domainArr.length;
      const _domain = _domainArr.slice(_doArrLen - 2, _doArrLen).join('.');

      return {
        name: 'cookie',
        isSupported: typeof document.cookie === 'string',
        init() {},
        /**
           * set
           * @param name 必须
           * @param value 必须
           * @param domain  可选
           * @param path  可选
           * @param hour  可选
           */
        set(name, value, domain, path, hour) {
          let expire;
          if (hour) {
            expire = new Date();
            expire.setTime(expire.getTime() + 3600000 * hour);
          }
          // eslint-disable-next-line max-len
          document.cookie = `${name}=${value}; ${expire ? (`expires=${expire.toGMTString()}; `) : ''}path=${path || '/'}; domain=${domain || _domain};`;
        },

        get(name) {
          const r = new RegExp(`(?:^|;\\s*)${name}=([^;]*)`); const
            m = document.cookie.match(r);
          // eslint-disable-next-line no-mixed-operators
          return m && m[1] || '';
        },

        del(name, domain, path) {
          // eslint-disable-next-line max-len
          document.cookie = `${name}=; expires=Mon, 26 Jul 1997 05:00:00 GMT; path=${path || '/'}; domain=${domain || _domain};`;
        },

        clear() {
          const m = document.cookie.match(/\w+=[^;]*/g);
          if (m) {
            for (let i = 0, l = m.length; i < l; i += 1) {
              this.del(m[i].split('=')[0]);
            }
          }
        },
      };
    }());
    /**
     * @property {Object} localStorage
     */
    this.localStorage = {
      name: 'localStorage',
      isSupported: !!window.localStorage,
      init() {},
      set(key, val) {
        localStorage.setItem(key, val);
      },

      get(key) {
        return localStorage.getItem(key);
      },

      del(key) {
        localStorage.removeItem(key);
      },

      clear() {
        localStorage.clear();
      },
    };
  }
}

export default new HybridStorage();
